import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { LoadingButton } from '../common/LoadingButton';
import { ensureDefaultAttribute } from '../common/utils/Attributes';
export class IconButtonComponent extends LoadingButton {
    constructor() {
        super(...arguments);
        this.badge = false;
    }
    badgeChanged(_oldValue, newValue) {
        if (newValue)
            this.attachBadge();
        else
            this.detachBadge();
    }
    connectedCallback() {
        super.connectedCallback();
        ensureDefaultAttribute(this, 'size', 'medium');
        ensureDefaultAttribute(this, 'variant', 'primary');
        if (this.hasAttribute('badge'))
            this.attachBadge();
    }
    attachBadge() {
        var _a, _b, _c;
        const badgeElement = document.createElement('chameleon-badge-counter');
        badgeElement.setAttribute('content-box', '');
        if (this.getAttribute('size') === 'medium' || this.getAttribute('size') === 'xsmall')
            badgeElement.setAttribute('size', 'small');
        else
            badgeElement.setAttribute('size', (_a = this.getAttribute('size')) !== null && _a !== void 0 ? _a : 'small');
        (_c = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('button')) === null || _c === void 0 ? void 0 : _c.appendChild(badgeElement);
    }
    detachBadge() {
        var _a, _b, _c;
        (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.querySelector('chameleon-badge-counter')) === null || _c === void 0 ? void 0 : _c.remove();
    }
}
__decorate([
    attr
], IconButtonComponent.prototype, "size", void 0);
__decorate([
    attr
], IconButtonComponent.prototype, "variant", void 0);
__decorate([
    attr({ mode: 'boolean' })
], IconButtonComponent.prototype, "badge", void 0);
